function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { LinkElement } from '@els/els-react--link-element';
import { ValidPropTypes, makeErrorBoundComponent, generateId } from '@els/els-react--utils';
import classnames from 'classnames';
import { string, bool, arrayOf, object } from 'prop-types';
var defaults = {
  activeId: null,
  activeIsLink: false,
  className: "",
  id: null,
  size: null
};
var NavGroup = function NavGroup(_ref) {
  var _ref$activeId = _ref.activeId,
    activeId = _ref$activeId === void 0 ? defaults.activeId : _ref$activeId,
    _ref$activeIsLink = _ref.activeIsLink,
    activeIsLink = _ref$activeIsLink === void 0 ? defaults.activeIsLink : _ref$activeIsLink,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults.id : _ref$id,
    linkElementData = _ref.linkElementData,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaults.size : _ref$size,
    title = _ref.title;
  var renderLink = function renderLink(link) {
    var isActive = link.id && link.id === activeId;
    var isALink = !isActive || isActive && activeIsLink;
    var linkClasses = classnames(link.className, {
      "c-els-nav-group__link": isALink,
      "c-els-nav-group__text": !isALink,
      "c-els-nav-group__link--active": isActive
    });
    return /* @__PURE__ */React.createElement("li", {
      className: "c-els-nav-group__item ".concat(size === "small" ? "c-els-nav-group__item--small" : ""),
      key: generateId(),
      "data-testid": "nav-group-item",
      "aria-current": isActive ? "page" : null
    }, isALink ? /* @__PURE__ */React.createElement(LinkElement, _objectSpread(_objectSpread({}, link), {}, {
      className: linkClasses
    })) : /* @__PURE__ */React.createElement("span", {
      className: linkClasses,
      id: link.id
    }, link.children));
  };
  return /* @__PURE__ */React.createElement("nav", {
    "aria-label": title,
    id: id,
    className: className,
    "data-testid": "nav-group"
  }, /* @__PURE__ */React.createElement("ul", {
    className: "c-els-nav-group"
  }, linkElementData.map(function (link) {
    return renderLink(link);
  })));
};
NavGroup.displayName = "NavGroup";
NavGroup.propTypes = {
  /** Id of active link */
  activeId: string,
  /** Active is normally not a link, this prop forces it to be */
  activeIsLink: bool,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string,
  /** ID for the NavGroup */
  id: string,
  /** Array of LinkElement configs. shape not filled out here to avoid need to maintain it in two places */
  linkElementData: arrayOf(object).isRequired,
  /** Font size, only small is available at present */
  size: string,
  /** Title for the navigation, used by screenreaders */
  title: string.isRequired
};
NavGroup.requiredProps = {
  linkElementData: ValidPropTypes.ARRAY,
  title: ValidPropTypes.STRING
};
NavGroup.defaults = defaults;
var RawNavGroup = NavGroup;
var NavGroup$1 = makeErrorBoundComponent(RawNavGroup);
export { NavGroup$1 as NavGroup, RawNavGroup };
